import "../styles/default.scss";

import moment from "moment-mini";
import React from "react";

import MediaMonitorAbstract from "../../../../../abstract/MediaMonitorAbstract";
import withUserData from "../../../../../hocs/withUserData";
import { PLAN_PERMISSIONS_SECTIONS } from "../../../../../redux/modules/auth/userPermissions/selector";
import MediaMonitorEntryContent from "../../MediaMonitorEntryContent/modules/default";
import PremiumIcon from "../../PremiumIcon/modules/default";
import SquaberButton from "../../SquaberButton";
import SquaberTable from "../../SquaberTable";

@withUserData
class MediaMonitor extends MediaMonitorAbstract {
  render() {
    const {
      data,
      mediaMonitor,
      mediaMonitorEntriesLoading,
      translate,
      canDisplaySection
    } = this.props;

    const monitor = mediaMonitor || data || { messages: [], is_last_page: true };

    return (
      <div className="media-monitor">
        <SquaberTable
          withDistinctRows
          className="media-monitor-table"
          rows={(monitor.messages || []).map(message => {
            const { pub_datetime, source } = message;
            const hour = moment(pub_datetime).format("HH:mm");

            return [
              <React.Fragment>
                {hour !== "00:00" ? <div>{hour}</div> : null}
                <div>{moment(pub_datetime).format("DD.MM.YYYY")}</div>
                <div>{source}</div>
              </React.Fragment>,
              <div className="premium-icon-wrapper">
                {message.is_premium ? (
                  <PremiumIcon
                    size={12}
                    userHasAccess={canDisplaySection(
                      PLAN_PERMISSIONS_SECTIONS.MEDIA_MONITOR
                    )}
                    regular
                  />
                ) : null}
              </div>,
              <MediaMonitorEntryContent {...message} />
            ];
          })}
        />
        {!monitor.is_last_page ? (
          <div className="button-wrapper text-center">
            <SquaberButton
              disabled={mediaMonitorEntriesLoading}
              onClick={this.onButtonClick}
            >
              {translate("More")}
            </SquaberButton>
          </div>
        ) : null}
      </div>
    );
  }
}

export default MediaMonitor;
